import request from "@/utils/request";
// 获取更换微信二维码
export function GetReceiverById(params) {
  return request({
    url: "/h5/index/getReceiverById",
    method: "post",
    params,
  });
}